// extracted by mini-css-extract-plugin
export default {"notificationBellVisible":"h_uMYm0V_hmePSMBxB_U","wpp-icon":"VQl4AeSJHJrXvQOsE0Vh"};